import React, {useState} from 'react';
import {getSessionStorageField, setSessionStorageField} from './contextHelper';

const navigateIfRouteAndOrHashProvided = (account, token) => {
  const url = window.location.href;
  let [newURL] = url.split('?');

  if (account && token) {
    const route = getSessionStorageField('route', null);
    const hash = getSessionStorageField('hash', null);

    if (route) {
      newURL += route;
      setSessionStorageField('route', null);
    }
    if (hash) {
      newURL += '#' + hash;
      setSessionStorageField('hash', null);
    }

    if (route || hash) {
      window.location.assign(newURL);
    }
  }
};

function useDeepLink(account, authAndContent) {
  const [mobileFilter, setMobileFilter] = useState(false);

  React.useEffect(() => {
    navigateIfRouteAndOrHashProvided(account.account, authAndContent.token);

    if (getSessionStorageField('mobile', null)) {
      setMobileFilter(true);
    } else {
      setMobileFilter(false);
    }

    // enable use of # to scroll to section on page
    if (!window.location.hash) {
      return;
    }

    const elementId = window.location.hash.substring(1);
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({behavior: 'smooth'});
    }
  }, [account.account, authAndContent.token]);

  React.useEffect(() => {
    const url = window.location.href;

    const [, queryString] = url.split('?');
    const queryParams = new URLSearchParams(queryString);

    const refreshToken = queryParams.get('refreshToken');
    const accessToken = queryParams.get('accessToken');
    const mobile = queryParams.get('mobile') === 'true' ? true : false;
    const route = queryParams.get('route');
    const hash = queryParams.get('hash');

    if (mobile) {
      setSessionStorageField('mobile', mobile);
    }
    if (route) {
      setSessionStorageField('route', route);
    }
    if (hash) {
      setSessionStorageField('hash', hash);
    }

    // if url contains session tokens, log user in & remove all queries (i.e. tokens)
    if (refreshToken && accessToken) {
      authAndContent.saveToken({refreshToken, accessToken});
    }
  }, []);

  return {mobileFilter};
}

export default useDeepLink;
